<div class="add-job-code-dialog">
  <!-- Header -->
  <div class="dialog-header">
    <h2>{{ viewMode === 'list' ? 'Select Job Code' : 'Add New Job Code' }}</h2>
    <button mat-icon-button (click)="close()">
      <mat-icon svgIcon="c:x"></mat-icon>
    </button>
  </div>

  <div class="dialog-content flex flex-col">
    <!-- MODE SWITCHER: either Search+AddButton OR ManualInput+Actions -->

    <!-- SEARCH MODE -->
    @if (viewMode === 'list') {
      <mat-form-field appearance="outline" class="w-full">
        <mat-icon matPrefix svgIcon="c:search"></mat-icon>
        <input matInput [formControl]="searchControl" placeholder="Search Job Codes...">
      </mat-form-field>
      <div class="flex justify-end mb-1">
        <button mat-button color="primary" class="font-bold text-xs" (click)="switchToAddMode()">
          <mat-icon class="icon-sm" svgIcon="c:plus"></mat-icon> ADD MANUALLY
        </button>
      </div>
    }

    <!-- MANUAL ADD MODE -->
    @if (viewMode === 'add') {
      <div class="flex gap-2 items-start w-full mt-2">
        <mat-form-field appearance="outline" class="w-full">
          <mat-label>Enter Job Code</mat-label>
          <input matInput [formControl]="manualJobCodeControl" placeholder="Type here..." (keydown.enter)="addJobCode()">
          @if (manualJobCodeControl.hasError('required')) {
            <mat-error>
              Required
            </mat-error>
          }
        </mat-form-field>
        <div class="flex gap-1 mt-1">
          <button mat-icon-button class="!bg-primary/10 !text-primary h-12 w-12 rounded-lg"
            (click)="addJobCode()"
            matTooltip="Save">
            <mat-icon svgIcon="c:check"></mat-icon>
          </button>
          <button mat-icon-button class="!bg-red-50 !text-red-500 h-12 w-12 rounded-lg"
            (click)="switchToListMode()"
            matTooltip="Cancel">
            <mat-icon svgIcon="c:x"></mat-icon>
          </button>
        </div>
      </div>
      <div class="text-xs text-gray-500 italic px-2 -mt-2 mb-2">
        Enter the new job code and click save to apply it.
      </div>
    }

    <!-- LOADING STATE -->
    @if (isLoading) {
      <div class="loading-container">
        <mat-spinner diameter="40"></mat-spinner>
        <p class="text-gray-500 mt-3">Loading job codes...</p>
      </div>
    }

    <!-- LIST (Visible in BOTH modes when not loading) - Using Virtual Scroll for performance -->
    @if (!isLoading && filteredWorkOrders.length > 0) {
      <cdk-virtual-scroll-viewport
        itemSize="56"
        class="job-code-list-viewport"
        >
        <!-- eslint-disable-next-line @angular-eslint/template/click-events-have-key-events, @angular-eslint/template/interactive-supports-focus -- pre-existing pattern; accessibility tracked under COL-37 -->
        <div *cdkVirtualFor="let item of filteredWorkOrders; trackBy: trackByJobCode"
          class="job-code-item"
          [class.selected]="item.woCode === currentJobCode"
          (click)="selectJobCode(item)">
          <div class="flex items-center gap-3">
            <!-- Check icon only for selected item -->
            @if (item.woCode === currentJobCode) {
              <mat-icon class="text-primary selected-icon" svgIcon="c:check-circle"></mat-icon>
            }
            @if (item.woCode !== currentJobCode) {
              <mat-icon class="text-gray-300 unselected-icon" svgIcon="c:circle"></mat-icon>
            }
            <div class="job-code-text">{{ item.woCode }}</div>
          </div>
          <mat-icon class="text-gray-400" svgIcon="c:chevron-right"></mat-icon>
        </div>
      </cdk-virtual-scroll-viewport>
    }

    @if (!isLoading && filteredWorkOrders.length === 0) {
      <div class="no-data">
        No job codes found
      </div>
    }
  </div>
</div>
